export default __webpack_public_path__ + "static/UTU_logo-44eadce6e5ab7a738440181c04317170.png";